export class ApiLogger {
  public constructor(
    private namespace: string,
    private isEnabled = true,
  ) {
    this.isEnabled = isEnabled;
  }

  public log(message: string, ...args: unknown[]): void {
    if (!this.isEnabled) {
      return;
    }

    console.log(`[${this.namespace}]`, message, ...args);
  }

  public info(message: string, ...args: unknown[]): void {
    if (!this.isEnabled) {
      return;
    }

    console.info(`[${this.namespace}]`, message, ...args);
  }

  public debug(message: string, ...args: unknown[]): void {
    if (!this.isEnabled) {
      return;
    }

    console.debug(`[${this.namespace}]`, message, ...args);
  }

  public warn(message: string, ...args: unknown[]): void {
    if (!this.isEnabled) {
      return;
    }

    console.warn(`[${this.namespace}]`, message, ...args);
  }

  /**
   * Error logging is always enabled, regardless of the `isLogEnabled` setting,
   * unless explicitly disabled by flags such as `isLog404Error`
   */
  public error(message: string, ...args: unknown[]): void {
    console.error(`[${this.namespace}]`, message, ...args);
  }
}
